import types from './mutation-types';
import BidService from '@/services/bid-service.js';
import ItemService from '@/services/item-service.js';
import { isNil } from 'lodash';
import { CancelToken } from 'axios';

let requestSource = null;

class Bids {

	constructor(commit, auctionId) {
		this.commit = commit;
		this.auctionId = auctionId;
	}

	fetchBids(params) {
		// cancel all current requests
		if (!isNil(requestSource)) {
			requestSource.cancel();
		}

		requestSource = CancelToken.source();

		this.commit(types.FETCH_BIDS_START);

		return BidService.getAuctionBids(this.auctionId, params, requestSource.token)
			.then(data => {
				this.commit(types.FETCH_BIDS_SUCCESS, {
					bids: data.data,
					meta: {
						currentPage: data.current_page,
						total: data.total,
						perPage: data.per_page,
						totalPages: this.calculateTotalPages(data.per_page, data.total)
					}
				});

			}).catch(error => this.commit(FETCH_BIDS_ERROR, error.errors));
	}

	calculateTotalPages(perPage, total) {
		return Math.ceil(total / perPage);
	}
}

const actions = {
	fetchAuctionBids({ commit }, { auctionId, params }) {
		return new Bids(commit, auctionId).fetchBids(params);
	},
	deleteBid({ commit }, { itemId, bidId }) {

		commit('DELETE_BID_START');

		return ItemService.deleteBid(itemId, bidId)
			.then(response => commit('DELETE_BID_SUCCESS'))
			.catch(error => commit('DELETE_BID_ERROR', error));

	}
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/bid-list/actions.js